'use strict';

exports.mergeOptions = function (defaults, options) {
    options = options || {};

    return [defaults, options].reduce(function (merged, optObj) {
        Object.keys(optObj).forEach(function (key) {
            merged[key] = optObj[key];
        });

        return merged;
    }, {});
};



//////////////////
// WEBPACK FOOTER
// ./~/parse5/lib/common/utils.js
// module id = 860
// module chunks = 0